"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var FormHeader = function FormHeader(_ref) {
    var title = _ref.title, subhead = _ref.subhead, className = _ref.className, _ref$noRule = _ref.noRule, noRule = _ref$noRule === void 0 ? false : _ref$noRule, _ref$noPadding = _ref.noPadding, noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding, _ref$invert = _ref.invert, invert = _ref$invert === void 0 ? false : _ref$invert;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, Object.assign({
        className: className
    }, {
        noPadding: noPadding,
        noRule: noRule,
        invert: invert
    }), /*#__PURE__*/ react_1.default.createElement(Header, Object.assign({
        invert: invert
    }, {
        dangerouslySetInnerHTML: {
            __html: title
        }
    })), subhead && /*#__PURE__*/ react_1.default.createElement(Subhead, Object.assign({
        invert: invert
    }, {
        dangerouslySetInnerHTML: {
            __html: subhead
        }
    })));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "FormHeader__Wrapper",
    componentId: "sc-16ncaet-0"
})(["padding:24px 0;border-top:1px solid ", ";", " margin-top:", ";", "{padding:32px 0;margin-top:40px;}", "{padding:40px 0;margin-top:48px;}", "{padding:48px 0;margin-top:64px;}"], function (props) {
    return !!props.invert ? _utils_1.rgba(_theme_1.palette.snow, 0.16) : _utils_1.rgba(_theme_1.palette.ink, 0.64);
}, function (props) {
    return props.noRule && "\n    padding-top: 0 !important;\n    border-top: none;\n  ";
}, function (props) {
    return !!props.noPadding ? '0 !important' : '32px';
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Header = styled_components_1.default.div.withConfig({
    displayName: "FormHeader__Header",
    componentId: "sc-16ncaet-1"
})(["position:relative;", " color:", ";&::after,&::before{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.15) * 1em);}&::after{margin-top:calc((1 - 1.4) * 1em);}"], _theme_1.type.h3Uppercase, function (props) {
    return !!props.invert ? _theme_1.palette.snow : _theme_1.palette.black;
});
var Subhead = styled_components_1.default.div.withConfig({
    displayName: "FormHeader__Subhead",
    componentId: "sc-16ncaet-2"
})(["position:relative;", " color:", ";&::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.3) * 1em);}&::after{margin-top:calc((1 - 1.5) * 1em);}", "{padding-top:24px;}"], _theme_1.type.pSmall, function (props) {
    return !!props.invert ? _theme_1.palette.snow : _theme_1.palette.black;
}, _utils_1.mediaQuery('desktop')); // Typing
exports.default = FormHeader;
